import { Crisp } from "crisp-sdk-web";
import { getEnvVar } from "../utils/helper";

const CRISP_WEB_ID = getEnvVar("REACT_APP_CRISP_WEB_ID");

export const CrispService = {
  init: () => {
    if (!CRISP_WEB_ID) return;

    if (!window.$crisp) {
      window.$crisp = [];
    }

    Crisp.configure(CRISP_WEB_ID);
  },
  reset: () => {
    if (typeof Crisp.reset === "function") {
      Crisp.reset();
    }
  },
};
